import Vue from 'vue'
import axios from 'axios'
import {clientKey, rota,userKeyT, gapeKey , autoKey } from '../global/utils'
//userKeyT,
let tokenKey = localStorage.getItem(rota) == "adminpainel" ?  localStorage.getItem(userKeyT) : localStorage.getItem(rota) == "gape" ? localStorage.getItem(gapeKey)  : localStorage.getItem(rota) == "autoespecialistas" ? localStorage.getItem(autoKey) : localStorage.getItem(clientKey) 
let urlApi = process.env.NODE_ENV === "development" ? 'https://localhost:44324/' : 'https://jeanpierre.webapp.com.br/webapi/'
axios.defaults.baseURL = urlApi
axios.defaults.headers.common['Authorization'] = `Bearer ${tokenKey}`;

const success = res => res
const error = err => {
    var obj;
    var keys;
    var i = 0;
    var kLength = 0;
    if (401 === err.response.status){
       // window.location = "/"
    }
    else if (404 === err.response.status){
        Vue.toasted.global.defaultError({msg: "Dados inválidos"})
       //obj = err.response.data;
       //keys = Object.keys(obj);
       //kLength = keys.length;
       //for (i; i < kLength; i++){
       //    if (keys[i] == "$.tsInclusao"){
       //        Vue.toasted.global.defaultError({msg: "Data inválida"})
       //    }else{
       //        Vue.toasted.global.defaultError({msg:err.response.data[keys[i]]})
       //    }
       //}
    }
    else if (403 === err.response.status){
        Vue.toasted.global.defaultError({msg: "Acesso proíbido"})
    }
    else if (400 === err.response.status){
        if (err.response.data.errors != undefined && err.response.data.errors != ''){
            obj = err.response.data.errors;
            keys = Object.keys(obj);
            kLength = keys.length;
            for (i; i < kLength; i++){
                if (keys[i] == "$.tsInclusao"){
                    Vue.toasted.global.defaultError({msg: "Data inválida"})
                }else{
                    Vue.toasted.global.defaultError({msg:err.response.data.errors[keys[i]]})
                }
            }
        }
        if (err.response.data.message != undefined && err.response.data.message != ''){
            obj = err.response.data;
            keys = Object.keys(obj);
            kLength = keys.length;
            for (i; i < kLength; i++){
                if (keys[i] == "$.tsInclusao"){
                    Vue.toasted.global.defaultError({msg: "Data inválida"})
                }else{
                    Vue.toasted.global.defaultError({msg:err.response.data[keys[i]]})
                }
            }           
        }
    }else{
        Vue.toasted.global.defaultError()
    }
    console.log(400 === err.response.status)
    return Promise.reject(err) 
}

Vue.use(axios)
axios.interceptors.response.use(success,error)

export default axios 
